<!--  -->
<template>
	<div class="head">
		<div class="left">
			<div class="time">{{date}}</div>
			<div :class="item.status == 0 ? 'head-item' : 'head-item nav'" v-if="i<=3" v-for="(item,i) in btndata"
				@click="check(i)" :key="i">{{item.name}}</div>
		</div>
		<div class="name">木棉树高速公路可视化管理平台</div>
		<div class="right">
			<div :class="item.status == 0 ? 'head-item' : 'head-item nav'" v-if="i>3" v-for="(item,i) in btndata"
				@click="check(i)" :key="i">{{item.name}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				btndata: [{
						name: "鸟瞰",
						status: 1
					},
					{
						name: "公路",
						status: 0
					},
					{
						name: "隧道",
						status: 0
					},
					{
						name: "路况",
						status: 0
					},
					{
						name: "立交",
						status: 0
					},
					{
						name: "收费站",
						status: 0
					},
					{
						name: "服务站",
						status: 0
					},
					{
						name: "巡检",
						status: 0
					}
				],
				date: "",
				xj:0,
				
				lk:0
			};
		},

		components: {},

		computed: {},

		created() {
			var myDate = new Date();
			myDate.getFullYear();
			myDate.getMonth();
			myDate.getDate();
			this.date =
				myDate.getFullYear() +
				"-" +
				myDate.getMonth() +
				1 +
				"-" +
				myDate.getDate();
		},

		methods: {
			closetc(){
				document.getElementById("iframe").contentWindow.document.getElementById('info1').style.display = 'none';
				document.getElementById("iframe").contentWindow.document.getElementById('info2').style.display = 'none';
				document.getElementById("iframe").contentWindow.document.getElementById('info3').style.display = 'none';
				document.getElementById("iframe").contentWindow.document.getElementById('info4').style.display = 'none';
				document.getElementById("iframe").contentWindow.document.getElementById('info5').style.display = 'none';
				document.getElementById("iframe").contentWindow.document.getElementById('info7').style.display = 'none';
				document.getElementById("iframe").contentWindow.document.getElementById('info8').style.display = 'none';
			},
			check(val) {
				// console.log(val);

				// if (val == 7) {
				//   if (this.btndata[7].status == 0) {
				//     this.btndata[7].status = 1;
				//     document
				//       .getElementById("iframe")
				//       .contentWindow.MMAPI.runrun("xunjian");
				//   } else {
				//     document.getElementById("iframe").contentWindow.stopxunjian();
				//     this.btndata[7].status = 0;
				//   }
				// } else if(val == 3){
				//   if (this.btndata[3].status == 0) {
				//     this.btndata[3].status = 1;
				//   } else {
				//     this.btndata[3].status = 0;
				//   }
				// } else {
				this.btndata.forEach((item, i) => {
					if (i == val) {
						item.status = 1;
						switch (val) {
							case 0:
								document.getElementById("iframe").contentWindow.MMAPI.objectTarget(0);
								this.closetc();
								this.xj = 0
								this.lk = 0
								break;
							case 1:
								document.getElementById("iframe").contentWindow.MMAPI.objectTarget(6);
								this.closetc();
								this.xj = 0
								this.lk = 0
								break;

							case 2:
								document.getElementById("iframe").contentWindow.MMAPI.objectTarget(2);
								this.closetc();
								this.xj = 0
								this.lk = 0
								break;
							case 3:
								document.getElementById("iframe").contentWindow.fenqu();
								this.closetc();
								this.xj = 0
								if(this.lk == 0){
									this.lk = 1;
								}else{
									this.btndata[3].status = 0;
									this.lk = 0
								}
								break;
							case 4:
								document.getElementById("iframe").contentWindow.MMAPI.objectTarget(1);
								this.closetc();
								this.xj = 0
								this.lk = 0
								break;
							case 5:
								document.getElementById("iframe").contentWindow.MMAPI.objectTarget(4);
								this.closetc();
								this.xj = 0
								this.lk = 0
								break;
							case 6:
								document.getElementById("iframe").contentWindow.MMAPI.objectTarget(3);
								this.xj = 0
								this.lk = 0
								this.closetc();
								break;
							case 7:
							if(this.xj == 0){
								document
									.getElementById("iframe")
									.contentWindow.MMAPI.runrun("xunjian");
									this.closetc();
								this.xj = 1
							}else{
								document.getElementById("iframe").contentWindow.stopxunjian();
								this.btndata[7].status = 0;
								this.btndata[0].status = 1;
								this.xj = 0
							}
							this.lk = 0
								break;

							default:
								break;
						}
					} else {
						// this.xj = 0;
						item.status = 0;

					}
				});
				// }

			}
		}
	};
</script>
<style lang="less" scoped>
	.head {
		height: 160px;
		width: 98%;
		margin-left: 1%;
		position: absolute;
		top: 0;
		left: 0;
		background: url(../assets/head.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		font-family: pmzd;

		.name {
			font-size: 28px;
			height: 70px;
			display: flex;
			font-family: "SourceHanSansCNVF";
			color: rgb(255, 255, 255);
			font-weight: bold;
			justify-content: center;
			align-items: center;
			font-family: pmzd;
		}

		.left {
			height: 30px;
			position: absolute;
			left: 0;
			top: 41px;
			width: 600px;
			display: flex;

			.time {
				width: 23%;
				color: #066acd;
				display: flex;
				font-size: 20px;
				align-items: center;
				justify-content: center;
				margin-left: 1.5%;
			}

			.head-item {
				color: #bcdeff;
				font-size: 20px;
				width: 25%;
				text-align: center;
				cursor: pointer;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.nav {
				color: #066acd;

				&:after {
					content: "";
					width: 60px;
					height: 10px;
					background: url(../assets/headnav.png);
					background-repeat: no-repeat;
					background-size: 100% 100%;
					position: absolute;
					margin-left: 0px;
					margin-top: 0px;
				}
			}
		}

		.right {
			position: absolute;
			right: 0;
			height: 30px;
			width: 600px;
			top: 41px;
			display: flex;

			.head-item {
				color: #bcdeff;
				font-size: 20px;
				width: 24%;
				text-align: center;
				cursor: pointer;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.nav {
				color: #066acd;

				&:after {
					content: "";
					width: 80px;
					height: 10px;
					background: url(../assets/headnav.png);
					background-repeat: no-repeat;
					background-size: 100% 100%;
					position: absolute;
					margin-left: 0px;
					margin-top: 0px;
				}
			}

			.nav:nth-child(1) {
				color: #066acd;

				&:after {
					content: "";
					width: 60px;
					height: 10px;
					background: url(../assets/headnav.png);
					background-repeat: no-repeat;
					background-size: 100% 100%;
					position: absolute;
					margin-left: 0px;
					margin-top: 0px;
				}
			}

			.nav:nth-child(4) {
				color: #066acd;

				&:after {
					content: "";
					width: 60px;
					height: 10px;
					background: url(../assets/headnav.png);
					background-repeat: no-repeat;
					background-size: 100% 100%;
					position: absolute;
					margin-left: 0px;
					margin-top: 0px;
				}
			}
		}
	}
</style>
